import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import { Headphones, Users, UserCheck, BarChart2 } from "lucide-react";
import SoportePage from "./SoportePage";
import UsersPage from "./UsersPage";
import ApprovalsPage from "./ApprovalsPage";
import StatsPage from "./StatsPage";

const TABS = [
  { key: "soporte",      label: "Soporte",      Icon: Headphones },
  { key: "usuarios",     label: "Usuarios",     Icon: Users },
  { key: "solicitudes",  label: "Solicitudes",  Icon: UserCheck },
  { key: "estadisticas", label: "Estadísticas", Icon: BarChart2 },
];

export default function AdminHubPage() {
  const location = useLocation();
  const [tab, setTab] = useState(location.state?.tab || "soporte");

  return (
    <div style={s.root}>
      <div style={s.tabBar}>
        {TABS.map(({ key, label, Icon }) => (
          <button
            key={key}
            style={{ ...s.tab, ...(tab === key ? s.tabActive : {}) }}
            onClick={() => setTab(key)}
          >
            <Icon size={15} />
            {label}
          </button>
        ))}
      </div>

      <div style={s.content}>
        {tab === "soporte"      && <SoportePage embedded />}
        {tab === "usuarios"     && <div style={s.scrollPane}><UsersPage /></div>}
        {tab === "solicitudes"  && <div style={s.scrollPane}><ApprovalsPage /></div>}
        {tab === "estadisticas" && <div style={s.scrollPane}><StatsPage /></div>}
      </div>
    </div>
  );
}

const s = {
  root: {
    display: "flex",
    flexDirection: "column",
    height: "calc(100vh - 72px)",
  },
  tabBar: {
    display: "flex",
    gap: 2,
    borderBottom: "2px solid var(--border)",
    flexShrink: 0,
    marginBottom: 0,
    paddingBottom: 0,
  },
  tab: {
    display: "flex",
    alignItems: "center",
    gap: 7,
    padding: "10px 22px",
    border: "none",
    background: "none",
    color: "var(--text-2)",
    fontWeight: 700,
    fontSize: 13,
    cursor: "pointer",
    fontFamily: "Montserrat, sans-serif",
    borderBottom: "2px solid transparent",
    marginBottom: -1,
    transition: "color .15s",
  },
  tabActive: {
    color: "#D4620D",
    borderBottom: "2px solid #D4620D",
  },
  content: {
    flex: 1,
    minHeight: 0,
    display: "flex",
    flexDirection: "column",
    paddingTop: 20,
  },
  scrollPane: {
    flex: 1,
    overflowY: "auto",
    paddingTop: 28,
  },
};
